"use client"

import { useQuery } from "@tanstack/react-query"
import { usePermissions } from "@/hooks/use-permissions"
import { SHOPIFY_PERMISSIONS } from "@/lib/auth/permissions.constants"
import {
  getAttributionModelPreferenceAction,
  type AttributionModelPreference,
} from "@/server-actions/shopify/attribution-model-preference"

export const attributionModelPreferenceQueryKey = (tenantId: string | null) =>
  ["shopify", "attribution-model-preference", tenantId] as const

export function useAttributionModelPreferenceQuery() {
  const { can, activeTenantId } = usePermissions()

  return useQuery<AttributionModelPreference>({
    queryKey: attributionModelPreferenceQueryKey(activeTenantId),
    enabled: Boolean(activeTenantId) && can(SHOPIFY_PERMISSIONS.VIEW),
    queryFn: async () => {
      const result = await getAttributionModelPreferenceAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
